import apolloClient from '../../apolloClient';
import devicesQueries from 'src/gql/queries/device';
import devicesMutation from 'src/gql/mutations/device';

const getDeviceById = async (variables) =>
  apolloClient.query({
    query: devicesQueries.GET_DEVICES_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const getDevicesByCustomerId = async (variables) =>
  apolloClient.query({
    query: devicesQueries.GET_DEVICES_BY_CUSTOMER,
    fetchPolicy: 'no-cache',
    variables,
  });

const getDevicesByCustomerIds = async (variables) =>
  apolloClient.query({
    query: devicesQueries.GET_DEVICES_BY_CUSTOMERS,
    fetchPolicy: 'no-cache',
    variables,
  });

const createDevice = async (variables) =>
  apolloClient.mutate({
    mutation: devicesMutation.CREATE_DEVICE,
    fetchPolicy: 'no-cache',
    variables,
  });

const updateDeviceById = async (variables) =>
  apolloClient.mutate({
    mutation: devicesMutation.UPDATE_DEVICE_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const deleteDeviceById = async (variables) =>
  apolloClient.mutate({
    mutation: devicesMutation.DELETE_DEVICE_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const setDevicePlaceOpened = async (variables) =>
  apolloClient.mutate({
    mutation: devicesMutation.SET_DEVICE_PLACE_OPENED,
    fetchPolicy: 'no-cache',
    variables,
  });

const getDevicesByIds = async (variables) =>
  apolloClient.query({
    query: devicesQueries.GET_DEVICES_BY_IDS,
    fetchPolicy: 'no-cache',
    variables,
  });

export default {
  getDeviceById,
  getDevicesByCustomerId,
  getDevicesByCustomerIds,
  createDevice,
  updateDeviceById,
  deleteDeviceById,
  setDevicePlaceOpened,
  getDevicesByIds,
};
